import * as z from "zod";
import { NodeResourceSchema } from "./compute-nodes.js";

export const SCREEN_DIRECT_PATH = "/screen";
export const SCREEN_DIRECT_ADMISSION_MS = 30_000;
export const SCREEN_DIRECT_RECHECK_MS = 1_000;
export const SCREEN_DIRECT_GRACE_MS = 6_000;
export const SCREEN_DIRECT_MARKER = 'name="rakazo-screen-transport" content="1"';

export const ScreenDirectEndpointSchema = z
  .string()
  .url()
  .refine((value) => {
    const url = new URL(value);
    return (
      url.protocol === "wss:" &&
      url.pathname === SCREEN_DIRECT_PATH &&
      !url.username &&
      !url.password &&
      !url.search &&
      !url.hash
    );
  });
export const ScreenDirectDescriptorSchema = z
  .object({
    version: z.literal(1),
    endpoint: ScreenDirectEndpointSchema,
    ticket: z
      .string()
      .min(40)
      .max(8_000)
      .regex(/^[A-Za-z0-9_-]+$/),
    admitBefore: z.number().int().positive(),
  })
  .strict();
export type ScreenDirectDescriptor = z.infer<typeof ScreenDirectDescriptorSchema>;

export const ScreenDirectGrantSchema = NodeResourceSchema.extend({
  version: z.literal(1),
  jti: z.string().uuid(),
  routeId: z.string().uuid(),
  botId: z.string().min(1).max(100),
  botGeneration: z.number().int().nonnegative(),
  computerGeneration: z.number().int().nonnegative(),
  runtimeInstanceId: z.string().regex(/^[A-Za-z0-9_-]{1,100}$/),
  mode: z.enum(["view", "control"]),
  controlLeaseId: z.string().max(200).nullable(),
  controlFence: z.number().int().nonnegative().nullable(),
  issuedAt: z.number().int().positive(),
  admitBefore: z.number().int().positive(),
  expiresAt: z.number().int().positive(),
})
  .strict()
  .refine((value) =>
    value.mode === "control"
      ? Boolean(value.controlLeaseId && value.controlFence !== null)
      : value.controlLeaseId === null && value.controlFence === null,
  );
export type ScreenDirectGrant = z.infer<typeof ScreenDirectGrantSchema>;
export const ScreenDirectAuthorizationSchema = z
  .object({
    ticket: ScreenDirectDescriptorSchema.shape.ticket,
    phase: z.enum(["admit", "recheck"]),
  })
  .strict();
export const ScreenDirectAuthenticateSchema = z
  .object({
    kind: z.literal("authenticate"),
    version: z.literal(1),
    ticket: ScreenDirectDescriptorSchema.shape.ticket,
  })
  .strict();
